import api from './api';

class ShipmentService {
    async getShipments() {
        return api.get('shipments/');
    }

    async getShipment(id) {
        return api.get(`shipments/${id}/`);
    }

    async trackShipment(tracking_number) {
        return api.get(`shipments/track/?tracking_number=${tracking_number}`);
    }
}

export default new ShipmentService();
